$(document).ready(function() {
    $('ul').on('click', 'li:eq(1) a', function() {
       $('html, body').animate({
            scrollTop: $('#faq-home').offset().top
        }, 800);
    });
    });


$(document).ready(function() {
 $('ul').on('click', 'li:eq(0) a', function() {
       $('html, body').animate({
            scrollTop: $('.junip-product-review-container').offset().top
        }, 800);
    });
  class Accordion {
constructor(el) {
// Store the <details> element
this.el = el;
// Store the <summary> element
this.summary = el.querySelector('summary');
// Store the <div class="content"> element
this.content = el.querySelector('.accordion__content');

// Store the animation object (so we can cancel it if needed)
this.animation = null;
// Store if the element is closing
this.isClosing = false;
// Store if the element is expanding
this.isExpanding = false;
// Detect user clicks on the summary element
this.summary.addEventListener('click', (e) => this.onClick(e));
}

onClick(e) {
// Stop default behaviour from the browser
e.preventDefault();
// Add an overflow on the <details> to avoid content overflowing
this.el.style.overflow = 'hidden';
// Check if the element is being closed or is already closed
if (this.isClosing || !this.el.open) {
this.open();
// Check if the element is being openned or is already open
} else if (this.isExpanding || this.el.open) {
this.shrink();
}
}

shrink() {
// Set the element as "being closed"
this.isClosing = true;

// Store the current height of the element
const startHeight = `${this.el.offsetHeight}px`;
// Calculate the height of the summary
const endHeight = `${this.summary.offsetHeight}px`;

// If there is already an animation running
if (this.animation) {
// Cancel the current animation
this.animation.cancel();
}

// Start a WAAPI animation
this.animation = this.el.animate({
// Set the keyframes from the startHeight to endHeight
height: [startHeight, endHeight]
}, {
duration: 200,
easing: 'linear'
});

// When the animation is complete, call onAnimationFinish()
this.animation.onfinish = () => this.onAnimationFinish(false);
// If the animation is cancelled, isClosing variable is set to false
this.animation.oncancel = () => this.isClosing = false;
}

open() {
// Apply a fixed height on the element
this.el.style.height = `${this.el.offsetHeight}px`;
// Force the [open] attribute on the details element
this.el.open = true;
// Wait for the next frame to call the expand function
window.requestAnimationFrame(() => this.expand());
}

expand() {
// Set the element as "being expanding"
this.isExpanding = true;
// Get the current fixed height of the element
const startHeight = `${this.el.offsetHeight}px`;
// Calculate the open height of the element (summary height + content height)
const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

// If there is already an animation running
if (this.animation) {
// Cancel the current animation
this.animation.cancel();
}

// Start a WAAPI animation
this.animation = this.el.animate({
// Set the keyframes from the startHeight to endHeight
height: [startHeight, endHeight]
}, {
duration:200,
easing: 'linear'
});
// When the animation is complete, call onAnimationFinish()
this.animation.onfinish = () => this.onAnimationFinish(true);
// If the animation is cancelled, isExpanding variable is set to false
this.animation.oncancel = () => this.isExpanding = false;
}

onAnimationFinish(open) {
// Set the open attribute based on the parameter
this.el.open = open;
// Clear the stored animation
this.animation = null;
// Reset isClosing & isExpanding
this.isClosing = false;
this.isExpanding = false;
// Remove the overflow hidden and the fixed height
this.el.style.height = this.el.style.overflow = '';
}
}

document.querySelectorAll('details').forEach((el) => {
new Accordion(el);
});
  $(document).ready(function(){
    $(".review-custom").click(function(e){
          e.preventDefault();
        $('html, body').animate({
    scrollTop: $(".junip-product-review-container").offset().top
}, 2000);
    });
});

});


$(document).ready(function(){
    $('.shopify_subscriptions_fieldset input[type="radio"]:checked').closest('.shopify_subscriptions_app_block_label').addClass('sub_active');
    $('.shopify_subscriptions_fieldset input[type="radio"]').on('click', function(){
      $('.shopify_subscriptions_app_block_label').removeClass('sub_active');
      $(this).closest('.shopify_subscriptions_app_block_label').addClass('sub_active');
    });
});
$(document).ready(function() {
  $('.shopify_subscriptions_app_block_label').click(function() {
    var radioButton = $(this).find('input[type="radio"]');
    if (!radioButton.prop('checked')) {
      radioButton.trigger('click');
    }
  });
});

/* scrolling */
// $(document).ready(function() {
//   $(".scroll_product").click(function(event) {
//     event.preventDefault(); // Prevent default behavior of anchor tag
//     console.log("aa");
//     var targetOffset = $("#product").offset().top;
//     $("html, body").animate({ scrollTop: targetOffset }, 3000);
//   });
// });
$(".scroll_product").click(function(event) {
    event.preventDefault(); // Prevent default behavior of anchor tag
    // Set body opacity to 0.5
    // Wait for 5 seconds
        var targetOffset = $("#product").offset().top;
        // Scroll to the target section
        $("#product")[0].scrollIntoView({ behavior: 'smooth' });
});